import { cn } from './cn.js'
import { LOCKUP_RATIO, MARK } from './mark.js'

export interface WordmarkProps {
  /** Font size of the word in px; the mark is scaled from it. */
  size?: number
  className?: string
}

/**
 * The mark set against the word it is the first letter of. "ramas" is real
 * Inter Tight rather than an outlined copy, so the lockup follows the app's
 * type instead of having to be re-exported whenever the type changes.
 */
export function Wordmark({ size = 28, className }: WordmarkProps) {
  const box = Math.round(size * LOCKUP_RATIO)
  return (
    <span className={cn('inline-flex items-center', className)}>
      <svg
        viewBox={`0 0 ${MARK.box} ${MARK.box}`}
        width={box}
        height={box}
        className="block shrink-0 text-accent"
        aria-hidden="true"
      >
        <g
          transform={`rotate(${MARK.tilt} 256 256)`}
          fill="none"
          stroke="currentColor"
          strokeWidth={MARK.w}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d={MARK.bowl} />
          <path d={MARK.bar} />
        </g>
      </svg>
      <span
        aria-hidden="true"
        className="font-display font-semibold text-ink"
        style={{
          fontSize: size,
          lineHeight: 1,
          letterSpacing: '-0.03em',
          marginLeft: -size * 0.04,
        }}
      >
        ramas
      </span>
      <span className="sr-only">Gramas</span>
    </span>
  )
}
